import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Avatar, Box,
    Button, Card, Flex, Loader, Text,
    Title,
} from '@mantine/core';
import {getToken} from "../../auth/service/authService";
import {BackendUrl} from "../../util/config";
import {Organization} from "../../models/Organization";
import {fetchMyOrganization} from "../../Services/OrganizationService";
import {NoMembership} from "../../ui/Organization/customer/NoMembership";
import {IconDownload, IconFile} from "@tabler/icons-react";

// Optional: If you do not want to prompt for direct file download,
// you could handle PDF display or do something else with the data.

interface TemplateType {
    id: number;
    name: string;
    pdfData?: string; // not typically sent in a listing, but included if your backend returns it
}

export const Templates = () => {
    const [templates, setTemplates] = useState<TemplateType[] | null>(null);
    const [organization, setOrganization] = useState<Organization | null>(null);

    const [templatesLoading, setTemplatesLoading] = useState(false)
    // Fetch templates on mount

    useEffect(() => {
        if(organization){
            fetchTemplates();
        }

    }, [organization]);

    useEffect(() => {
        fetchMyOrganization().then((response) => {
            setOrganization(response);
        });
    }, []);

    const fetchTemplates = async () => {
        setTemplatesLoading(true)
        try {
            const res = await axios.get<TemplateType[]>(BackendUrl + '/templates', {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
            });
            setTemplates(res.data);
        } catch (err) {
            console.error('Error fetching templates:', err);
        }
        setTemplatesLoading(false)
    };

    const handleDownload = async (documentId: number, fileName: string) => {
        try {
            // Download document as Blob
            const blobData = await downloadDocument(documentId);

            // Determine MIME type and extension based on the file name or blob's type
            let mimeType = blobData.type;
            let extension = '';

            // Check if the fileName already has a valid extension
            if (fileName.toLowerCase().endsWith('.pdf')) {
                extension = '.pdf';
                mimeType = 'application/pdf';
            } else if (fileName.toLowerCase().endsWith('.docx')) {
                extension = '.docx';
                mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            } else {
                // If no extension is present, check the blob's type
                if (blobData.type === 'application/pdf') {
                    extension = '.pdf';
                } else if (
                    blobData.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                ) {
                    extension = '.docx';
                } else {
                    // Fallback to PDF if type is not recognized
                    extension = '.pdf';
                    mimeType = 'application/pdf';
                }
                fileName = fileName + extension;
            }

            // Create a new Blob with the correct MIME type
            const fileBlob = new Blob([blobData], { type: mimeType });
            const url = window.URL.createObjectURL(fileBlob);

            // Create an anchor element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            // Cleanup the DOM and URL object
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            alert('Failed to download the document.');
        }
    };

    const downloadDocument = async ( templateId: number): Promise<Blob> => {
        const response = await axios.get(BackendUrl + `/templates/${templateId}/pdf`, {
            headers: {
                Authorization: "Bearer " + getToken()
            },
            responseType: 'blob',
        });
        return response.data;
    };

    // If user has no organization, show a fallback
    if (!organization) {
        return (
            <NoMembership />
        );
    }

    return (
        <div style={{ position: 'relative', padding: '1rem' }}>

            <Flex justify={"flex-start"} align={"center"} gap={"15px"} mb="md">
                <Title order={2} >
                    Vorlagen
                </Title>
                <Text>*Die Vorlagen unterliegen keiner rechtlichen Prüfung</Text>
            </Flex>

            {templatesLoading && <Loader></Loader>}


            {templates && templates.length === 0 ? (
                <Text>Keine Vorlagen gefunden</Text>
            ) : <>{templates?.map((t) => (
                <Box mt="md" >
                    <Card withBorder shadow="sm" padding="md">
                        <Flex align="center">
                            <Avatar size="lg" radius="sm" variant="light">
                                <IconFile size={24} />
                            </Avatar>
                            <div style={{ flex: 1, marginLeft: 10 }}>
                                <Text w={500}>{t.name}</Text>
                            </div>
                            <Button
                                key={t.id}
                                variant={"filled"}
                                size="xs"
                                onClick={() => handleDownload(t.id, t.name)}
                                style={{marginRight: '5px'}}
                                leftSection={<IconDownload size={16} />}
                            >
                                Herunterladen
                            </Button>
                        </Flex>
                    </Card>
                </Box>))}</>}

        </div>
    );
}
